import type { FilterDefinition, FilterValue } from "@/ds";
import {
  LISTA_TOOLBAR_SEARCH_MAX_LENGTH,
  LISTA_TOOLBAR_SEARCH_PLACEHOLDER,
  LISTA_TOOLBAR_VIEW_OPTIONS,
} from "./lista-toolbar.constants";
import type { ListaToolbarProps, ListaToolbarViewModel } from "./types-lista-toolbar";

const SEM_DEFINICOES: FilterDefinition[] = [];
const SEM_VALOR: FilterValue = {};
const SEM_MUDANCA = () => undefined;

export function useListaToolbar({
  filterDefinitions = SEM_DEFINICOES,
  filterValue = SEM_VALOR,
  onFilterChange = SEM_MUDANCA,
  search = "",
  onSearchChange,
  onViewChange,
  searchPlaceholder = LISTA_TOOLBAR_SEARCH_PLACEHOLDER,
  wideSearch,
  searchWidth,
  ...props
}: ListaToolbarProps): ListaToolbarViewModel {
  const { isMobile, testIdPrefix } = props;

  return {
    ...props,
    search,
    searchWidth: isMobile ? "fill" : (searchWidth ?? (wideSearch ? "wide" : "compact")),
    searchSize: isMobile ? "small" : undefined,
    showSearch: onSearchChange !== undefined,
    controlSize: isMobile ? "small" : undefined,
    filterDefinitions,
    filterValue,
    onFilterChange,
    showFilters: filterDefinitions.length > 0,
    viewOptions: LISTA_TOOLBAR_VIEW_OPTIONS,
    showViewSwitch: onViewChange !== undefined,
    changeView: (next) => onViewChange?.(next),
    searchPlaceholder,
    testIds: {
      root: `${testIdPrefix}-toolbar`,
      search: `${testIdPrefix}-search`,
      filters: `${testIdPrefix}-filters`,
      menu: `${testIdPrefix}-menu`,
    },
    viewOptionTestId: (mode) => `${testIdPrefix}-view-${mode}`,
    changeSearch: (next: string) =>
      onSearchChange?.(next.slice(0, LISTA_TOOLBAR_SEARCH_MAX_LENGTH)),
  };
}
